import { getSnapshot, getParent, getIdentifier } from 'mobx-state-tree';
import defaults from 'lodash/defaults';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { DateTime } from 'luxon';

import I18n from '~/utils/i18n';

import { ISensorModel } from './model';

export function getConfiguration(self: ISensorModel) {
  const mappedConfig = Object.entries(self.configuration || {}).reduce(
    (acc, [key, value]) => {
      // eslint-disable-next-line no-param-reassign
      acc[key] = isArray(value) ? null : value;
      return acc;
    },
    {} as Record<string, any>
  );

  return defaults({}, getSnapshot(self), mappedConfig, get(self.extra_configuration, self.model, {}));
}

export default (self: ISensorModel) => {
  function parseConnection() {
    return self.connection.split('.');
  }
  return {
    get node() {
      return getParent<INode>(self, 3);
    },
    get model() {
      return self.getDataPointByName('model')?.lastValue || self.name;
    },
    get formValues() {
      return getConfiguration(self);
    },
    get firmware() {
      return self.getDataPointByName('firmware')?.lastValue;
    },
    get serial() {
      return self.getDataPointByName('serial')?.lastValue;
    },
    get comPort() {
      return get(parseConnection(), '[1]');
    },
    get comType() {
      return get(parseConnection(), '[2]');
    },
    get address() {
      return get(parseConnection(), '[3]');
    },
    get status() {
      return self.getDataPointByName('status')?.lastValue;
    },
    get path() {
      return getIdentifier(self)?.split(':')[1];
    },
    statusType() {
      const now = DateTime.now().toUTC().toMillis();
      if (self.hasError) {
        return 'error';
      }
      if (now - self.lastTs <= self.node?.extraReportingInterval) {
        return 'online';
      }
      return 'offline';
    },
    statusText() {
      const status = self.statusType();
      if (self.hasError) {
        return self.displayErrors.map((dp) => dp.name).join('\n');
      }
      return I18n.t(`devices.statuses.${status}`, { defaultValue: I18n.t('devices.statuses.empty') });
    },
    parseFormValues(values) {
      return values;
    },
    get modelName() {
      const model = self.model || self.name;
      return I18n.t(`filters.filter-tags.sensors.${model.toLowerCase()}`, { defaultValue: model });
    },
    get isAethairPro() {
      return self.node?.thiamis?.isAethairPro;
    },
    get icon() {
      if (self.isAethairPro) {
        return `aethair-pro-${self.path}`;
      }
      return self.model;
    }
  };
};
